import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './components/Dashboard'
import Leads from './components/Leads'
import LeadDetail from './components/LeadDetail'
import Pipeline from './components/Pipeline'
import Followups from './components/Followups'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="leads" element={<Leads />} />
          <Route path="leads/:id" element={<LeadDetail />} />
          <Route path="pipeline" element={<Pipeline />} />
          <Route path="followups" element={<Followups />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
